import React, {useContext, useMemo, useState} from "react";
import NewProductItm from "../newProductItm/NewProductItm";
import productsContext from "../../context/productos/productsContext";
import './ProductosSubtabla.css';
import Swal from "sweetalert2";
import { createEstructuraProducto, estructura_producto } from "../../utils/estructuras";

/*
    tablaSeleccionada se setea a componentes, caso de que reciba un valor se utilizara el especificado.
    Esto se hace asi ya que FormActivo tiene un renderizado condicional en base a este valor.
    ProcedimientoForm
*/
const ProductosSubtabla = ({req = {}, setState = () => console.log('setRequeriment'), productos, handleChangeProductos, handleDeleteProd, componentePadre = 'Procedimiento', modo='Nuevo', tablaSeleccionada, hasWebServiceConfigured}) => {

    const prodContext = useContext(productsContext);
    const { products, getProductsFromConsumo } = prodContext;
    const [consToGet, setConsToGet] = useState(null); //Remito consumo a obtener desde Softland.

    const productsFiltered = useMemo(()=> (componentePadre == 'FormConsumo' || componentePadre == 'FormOPD') ? products.filter(p => p.enableCons) : products, [products, componentePadre]);

    const handleGetItems = async() =>{
        alert((consToGet == null || consToGet == "") ? 0 : consToGet)
    }

    const handleGetProductsFromConsumo = async() => {
        if(hasWebServiceConfigured){
        let productsNotFound = [];
        let res = await getProductsFromConsumo(req);
            try {
                if(res.obtenidos){
                    Swal.fire('Aguarde un momento...')
                    setState({...req, productos: [createEstructuraProducto()]});
                    let productosToSet = [];
                    let i = 0;
                    res.productos.forEach((p, indexToSet) => {
                        let productFound = productsFiltered.find(prod => p.artCod == prod.artCod && p.tipPro == prod.tipPro);
                        if(productFound == undefined || productFound == null){
                            productsNotFound.push(p);
                        }else{
                            productosToSet.push({...p, precio: productFound ? productFound.precio : 0});
                            
                        }
                    })
                    if(productsNotFound.length == 0){
                        handleChangeProductos({}, 0, '', '', productosToSet);
                        Swal.fire({
                            title: 'Éxito',
                            icon: 'success',
                            text: res.msg
                        })        
                    } 
                    else {
                        Swal.fire({
                            title: 'No se puede ejecutar la recuperación!',
                            icon: 'error',
                            html: `Los productos ${productsNotFound.map(p => `<strong>${p.descrp}</strong>`).join(' , ')} no existen en la base de XertuX.`
                        })
                        console.log("productsNotFound");
                        console.log(productsNotFound);
                    }
                }else{
                    Swal.fire({
                        title: 'No se puede ejecutar la recuperación!',
                        icon: 'error',
                        text: res.msg
                    })
                }
            } catch (error) {
                console.log("Error en handleGetProductsFromConsumo");
                console.log(error);
                Swal.fire({
                    title: 'Error',
                    icon: 'error',
                    text: error.message
                })
            }
        }else{
            Swal.fire({
                title:"No es posible actualizar desde Consumos Reales!", 
                html:"No se ha configurado una conexión con un sistema externo. <br> Si desea configurar un sistema externo comuníquese con el soporte de XertuX",
                confirmButtonColor:'#3d4d87',
            });
        }
    }

    return <div className={`${(tablaSeleccionada != 'componentes') && 'inactive'} tareasDiv`}>
    <div className="subtablaHeaderLabel">
        <label>Materiales por {componentePadre == 'Activo' ? 'Activo' : componentePadre == 'FormReq' ? 'Orden de Trabajo' : componentePadre == 'FormConsumo' ? 'Consumo' : componentePadre == 'FormOPD' ? 'OPD' : 'Procedimiento'}</label> 
        {componentePadre == 'FormReq' && <button className="btn" onClick={handleGetProductsFromConsumo}>Actualizar desde Consumos Reales</button>}
    </div>
    <div className="productosXprocedimiento">
        <div className="productosDiv"> 
            {productos.map((p,index) => <NewProductItm data={p} index={index} key={index} productsList={productsFiltered} agregaItem={handleChangeProductos} borraItem = {handleDeleteProd} componentePadre={componentePadre} modo={modo}
            />)}
        </div>
    </div>
</div>
}

export default React.memo(ProductosSubtabla);